module.exports = __webpack_public_path__ + "img/stream-first-view.1bff5ff.gif";